const changeFormatPhoneNumber = (value) => {
  if (!value) return value

  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length
  if (phoneNumberLength < 4) return phoneNumber
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}

export const formatPhoneNumber = (value) => {
  if (!value) return ''
  if (value.length <= 3) return value
  if (value.includes('+ 1')) {
    return '+1 ' + changeFormatPhoneNumber(value.replace('+1 ', ''))
  } else if (value.includes('+1')) {
    return '+1 ' + changeFormatPhoneNumber(value.replace('+1', ''))
  } else {
    return '+1 ' + changeFormatPhoneNumber(value)
  }
}